module.exports = __webpack_public_path__ + "img/logo_wihte.4a93c6b0.png";